import React from "react";
import Banner from "../../components/Banner";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Select from "react-select";
import Spinner from "../../components/Spinner";
import "../../css/Wireframe.css";

const API = localStorage.getItem("assethost");

// Regex from helper.ts
const usernameRegex = /^(?!\s*$)[-_a-zA-Z0-9 ]*$/;
const usernameError =
  "Username should only contain letters, digits, dash, or underscore";
export default class PaymentAccountSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,valid:false,
      msg: "",
      toastColor: "",
      accounts: [],
      account: {
        id: 0,
        merchantCode: "",
        merchantPin: "",
        merchantNumber: "",
        mobileMoneyName: "",
        postUrl: "",
        username: "",
        password: "",
        passwordConfirm: "",
        activeStatus: "YES",
      },
      editing: false,
      page: 0,
      size: 10,
      totalPages: 1,
      errors: {},
      mobileMoneyNames: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.handlePreviousPage = this.handlePreviousPage.bind(this);
    this.handleNextPage = this.handleNextPage.bind(this);
    this.validate = this.validate.bind(this);
    this.fetchAccounts = this.fetchAccounts.bind(this);
    this.fetchAccountById = this.fetchAccountById.bind(this);
    this.fetchMobileMoneyNames = this.fetchMobileMoneyNames.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      return;
    }
    this.fetchMobileMoneyNames(token);
    this.fetchAccounts(0, 10, token);
  }

  fetchMobileMoneyNames(token) {
    axios
      .get(API + "/settings/getmobilemoneynames", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        this.setState({ mobileMoneyNames: response.data || [] });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to load mobile money names.",
          toastColor: "danger",
        });
      });
  }

  fetchAccounts(page, size, token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + "/settings/getallpaymentaccounts", {
        params: { page, size },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        let accounts = [];
        let totalPages = 1;
        if (response.data && Array.isArray(response.data)) {
          accounts = response.data;
        } else if (
          response.data &&
          response.data.content &&
          Array.isArray(response.data.content)
        ) {
          accounts = response.data.content;
          totalPages = response.data.totalPages || 1;
        } else {
          accounts = [];
        }
        this.setState({
          accounts,
          page,
          totalPages,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          accounts: [],
          totalPages: 1,
          loading: false,
          error:
            error?.response?.data?.message ||
            "Failed to load payment accounts.",
          msg:
            error?.response?.data?.message ||
            "Failed to load payment accounts.",
          toastColor: "danger",
        });
      });
  }

  fetchAccountById(id, token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + `/settings/getpaymentaccount/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const data = response.data || {};
        this.setState(
          {
            account: {
              ...data,
              passwordConfirm: data.password || "",
            },
            editing: true,
            loading: false,
          },
          this.validate
        );
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          error:
            error?.response?.data?.message || "Failed to load payment account.",
          msg:
            error?.response?.data?.message || "Failed to load payment account.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    const newAccount = { ...this.state.account, [name]: value };
    this.setState({ account: newAccount }, this.validate);
  }

  handleSelect(name, selectedOption) {
    const value = selectedOption ? selectedOption.value : "";
    const newAccount = { ...this.state.account, [name]: value };
    this.setState({ account: newAccount }, this.validate);
  }

  validate() {
    const s = this.state.account;
    const errors = {};
    let valid = true;

    // Explicit validation like in registration examples
    if (!s.merchantCode || !s.merchantCode.trim()) {
      errors.merchantCode = "Merchant code is required";
      valid = false;
    }
    if (!s.merchantPin || !s.merchantPin.trim()) {
      errors.merchantPin = "Merchant pin is required";
      valid = false;
    }
    if (!s.merchantNumber || !s.merchantNumber.trim()) {
      errors.merchantNumber = "Merchant number is required";
      valid = false;
    }
    if (!s.mobileMoneyName || !s.mobileMoneyName.trim()) {
      errors.mobileMoneyName = "Mobile money is required";
      valid = false;
    }
    if (!s.postUrl || !s.postUrl.trim()) {
      errors.postUrl = "Post URL is required";
      valid = false;
    }
    if (!s.username || !s.username.trim()) {
      errors.username = "Username is required";
      valid = false;
    } else if (!usernameRegex.test(s.username)) {
      errors.username = usernameError;
      valid = false;
    }
    if (!s.password || !s.password.trim()) {
      errors.password = "Password is required";
      valid = false;
    }
    if (!s.passwordConfirm || !s.passwordConfirm.trim()) {
      errors.passwordConfirm = "Password confirm is required";
      valid = false;
    } else if (s.password !== s.passwordConfirm) {
      errors.passwordConfirm = "Passwords do not match";
      valid = false;
    }
    if (!s.activeStatus || !s.activeStatus.trim()) {
      errors.activeStatus = "Active status is required";
      valid = false;
    }

    this.setState({ errors, valid });
    return valid;
  }

  handleSave(e) {
    if (e) e.preventDefault();
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      return;
    }
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });

    const request = { ...this.state.account };

    const self = this;
    axios
      .post(API + "/settings/paymentaccountsave", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          self.setState({
            msg: "Payment account saved successfully!",
            toastColor: "success",
            loading: false,
          });
          const currentPage = self.state.page;
          self.fetchAccounts(currentPage, self.state.size, token);
          self.setState({
            account: {
              id: 0,
              merchantCode: "",
              merchantPin: "",
              merchantNumber: "",
              mobileMoneyName: "",
              postUrl: "",
              username: "",
              password: "",
              passwordConfirm: "",
              activeStatus: "YES",
            },
            editing: false,
            errors: {},
          });
        } else {
          self.setState({
            msg: response.data.message || "Failed to save payment account.",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to save payment account. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  handleEdit(account) {
    const token = sessionStorage.getItem("token");
    if (account && account.id) {
      this.fetchAccountById(account.id, token);
    } else {
      this.setState(
        {
          account: {
            id: 0,
            merchantCode: "",
            merchantPin: "",
            merchantNumber: "",
            mobileMoneyName: "",
            postUrl: "",
            username: "",
            password: "",
            passwordConfirm: "",
            activeStatus: "YES",
          },
          editing: true,
          errors: {},
        },
        this.validate
      );
    }
  }

  handleCancelEdit() {
    this.setState({
      account: {
        id: 0,
        merchantCode: "",
        merchantPin: "",
        merchantNumber: "",
        mobileMoneyName: "",
        postUrl: "",
        username: "",
        password: "",
        passwordConfirm: "",
        activeStatus: "YES",
      },
      editing: false,
      errors: {},
    });
  }

  handlePreviousPage() {
    if (this.state.page > 0) {
      const token = sessionStorage.getItem("token");
      this.fetchAccounts(this.state.page - 1, this.state.size, token);
    }
  }

  handleNextPage() {
    if (this.state.page + 1 < this.state.totalPages) {
      const token = sessionStorage.getItem("token");
      this.fetchAccounts(this.state.page + 1, this.state.size, token);
    }
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-vh-100 d-flex justify-content-between bg-white">
        <Sidebar />
        <div className="min-vh-100 flex-grow-1 d-flex flex-column">
          <Banner title="Payment Account Settings" />
          {divMsg}
          <div className="d-flex flex-column flex-grow-1 px-5 h-60">
            {s.editing ? (
              // Edit/Add Form
              <form
                className="d-flex flex-column align-items-center w-100 mt-2 pt-3 pb-2 h-100 overflow-auto"
                autoComplete="off"
                onSubmit={this.handleSave}
              >
                <div className="row g-3 mx-auto" style={{maxWidth: 62 + 'rem'}}>
                  <div className="input-group">
                    <label className="input-group-text">Merchant Code</label>
                    <input
                      name="merchantCode"
                      className={`form-control ${
                        s.errors.merchantCode ? " !border-red-500" : ""
                      }`}
                      value={s.account.merchantCode}
                      onChange={this.handleChange}
                      required
                      autoFocus
                    />
                    {s.errors.merchantCode && (
                      <span className="input-group-error">
                        {s.errors.merchantCode}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Merchant Pin</label>
                    <input
                      name="merchantPin"
                      className={`form-control ${
                        s.errors.merchantPin ? " !border-red-500" : ""
                      }`}
                      value={s.account.merchantPin}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.merchantPin && (
                      <span className="input-group-error">
                        {s.errors.merchantPin}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Merchant Number</label>
                    <input
                      name="merchantNumber"
                      className={`form-control ${
                        s.errors.merchantNumber ? " !border-red-500" : ""
                      }`}
                      value={s.account.merchantNumber}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.merchantNumber && (
                      <span className="input-group-error">
                        {s.errors.merchantNumber}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Mobile Money</label>
                    <Select
                      name="mobileMoneyName"
                      value={
                        s.mobileMoneyNames.length > 0
                          ? {
                              value: s.account.mobileMoneyName,
                              label: s.account.mobileMoneyName,
                            }
                          : null
                      }
                      onChange={(selected) =>
                        this.handleSelect("mobileMoneyName", selected)
                      }
                      className={`form-control ${
                        s.errors.mobileMoneyName ? " !border-red-500" : ""
                      }`}
                      required
                      options={s.mobileMoneyNames.map((name) => ({
                        value: name,
                        label: name,
                      }))}
                    />
                    {s.errors.mobileMoneyName && (
                      <span className="input-group-error">
                        {s.errors.mobileMoneyName}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Post URL</label>
                    <input
                      name="postUrl"
                      type="url"
                      className={`form-control ${
                        s.errors.postUrl ? " !border-red-500" : ""
                      }`}
                      value={s.account.postUrl}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.postUrl && (
                      <span className="input-group-error">
                        {s.errors.postUrl}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Username</label>
                    <input
                      name="username"
                      className={`form-control ${
                        s.errors.username ? " !border-red-500" : ""
                      }`}
                      value={s.account.username}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.username && (
                      <span className="input-group-error">
                        {s.errors.username}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Password</label>
                    <input
                      name="password"
                      type="password"
                      className={`form-control ${
                        s.errors.password ? " !border-red-500" : ""
                      }`}
                      value={s.account.password}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.password && (
                      <span className="input-group-error">
                        {s.errors.password}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Password Confirm</label>
                    <input
                      name="passwordConfirm"
                      type="password"
                      className={`form-control ${
                        s.errors.passwordConfirm ? " !border-red-500" : ""
                      }`}
                      value={s.account.passwordConfirm}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.passwordConfirm && (
                      <span className="input-group-error">
                        {s.errors.passwordConfirm}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Active Status</label>
                    <select
                      name="activeStatus"
                      className={`form-control ${
                        s.errors.activeStatus ? " !border-red-500" : ""
                      }`}
                      value={s.account.activeStatus}
                      onChange={this.handleChange}
                      required
                    >
                      <option value="YES">Yes</option>
                      <option value="NO">No</option>
                    </select>
                    {s.errors.activeStatus && (
                      <span className="input-group-error">
                        {s.errors.activeStatus}
                      </span>
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-center gap-3 mt-4">
                  {s.valid && (
                    <button type="submit" className="btn btn-primary">
                      Save
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.handleCancelEdit}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            ) : (
              // Table View
              <div className="h-full w-full">
                <div className="d-flex gap-2 mb-2 align-items-baseline justify-content-between">
                  <h3 className="fw-bold">Configured Payment Accounts</h3>
                  <button
                    className="hover:font-bold flex gap-1 group"
                    onClick={() => this.handleEdit(null)}
                  >
                    <i
                      className="bi bi-plus-circle group-hover:scale-105"
                      style={{ color: "black" }}
                    ></i>
                    Add
                  </button>
                </div>
                {s.accounts.length === 0 ? (
                  <div className="text-gray-500">
                    No payment accounts found.
                  </div>
                ) : (
                  <div className="overflow-x-auto w-full border h-[93%] relative overflow-y-auto">
                    <table className="table table-striped table-hover rounded">
                      <thead className="table-light sticky-top">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            ID
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Merchant Number
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Provider
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Status
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="">
                        {s.accounts.map((account, index) => (
                          <tr key={index} className="hover:bg-gray-50">
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {account.id}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {account.merchantNumber}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {account.mobileMoneyName}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {account.activeStatus}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                              <button
                                className="btn btn-primary"
                                onClick={() => this.handleEdit(account)}
                              >
                                Edit
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {s.totalPages > 1 && (
                  <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
                    <button
                      className="btn btn-outline"
                      disabled={s.page === 0}
                      onClick={this.handlePreviousPage}
                    >
                      Previous
                    </button>
                    <span>
                      Page {s.page + 1} of {s.totalPages}
                    </span>
                    <button
                      className="btn btn-outline"
                      disabled={s.page + 1 >= s.totalPages}
                      onClick={this.handleNextPage}
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
          
        </div>
      </div>
    );
  }
}
